import { Box, Button, Card, CardContent, CircularProgress, Grid, TextField } from '@mui/material'
import { useRef, useState } from 'react';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import { useAddNoteMutation } from '../../../../../graphql/generated/graphql';
import { useUserInfoState } from '../../../../hooks/userInfo';
import { useProjectsState } from '../../../../hooks/projectsInfo';
import { setAlertDescription } from '../../../../hooks/actions';

const modules = {
    toolbar: {
        container: '#toolbar',
    }
}

const CustomToolbar = () => (
    <div id="toolbar">
        <button className="ql-underline" />
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-strike" />
        <button className="ql-list" value='check' />
        <button className="ql-list" value='ordered' />
        <button className="ql-list" value='bullet' />
    </div>
);

interface AddNotesProps {
    refetch: any
}

const AddNotes = (props: AddNotesProps) => {

    const { refetch } = props
    const projectsState = useProjectsState();
    const currentProject = projectsState.projectId.get();
    const userInfoState = useUserInfoState();
    const [content, setContent] = useState('');
    const [title, setTitle] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const quillRef = useRef<any>();
    const [addNote] = useAddNoteMutation();

    const saveNote = async () => {
        setIsLoading(true)
        try {
            await addNote({
                variables: {
                    project_id: currentProject as string,
                    user_id: userInfoState.user.get()?.id as string,
                    title: title,
                    content: content
                },
            }).then((res) => {
                setIsLoading(false);
                setAlertDescription({
                    open: true,
                    message: 'The Note has been added succesfully',
                    severity: 'success',
                })
                if (refetch) {
                    refetch();
                    setContent('');
                    setTitle('');
                }
            })
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Grid
            sx={{
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            <Card
                sx={{
                    width: '800px',
                }}
            >
                <CardContent
                    sx={{
                        paddingTop: '10px',
                        paddingBottom: '16px !important',
                        paddingX: '24px'
                    }}
                >
                    <TextField
                        fullWidth
                        InputProps={{
                            className: 'input-text-title',
                            disableUnderline: true,
                        }}
                        placeholder="Add title..."
                        variant="standard"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <hr />
                    <ReactQuill
                        theme="snow"
                        ref={quillRef}
                        value={content}
                        onChange={setContent}
                        modules={modules}
                        style={{
                            width: '100%',
                        }}
                        placeholder="write ..."
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <CustomToolbar />
                        <Button
                            sx={{
                                width: '20%',
                                marginRight: 1,
                                height: '32px'
                            }}
                            variant="contained"
                            onClick={saveNote}
                            disabled={!content || content === '<p><br></p>'}
                        >
                            {isLoading ?
                                <CircularProgress
                                    color="secondary"
                                    size={20}
                                /> : 'Add'}
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default AddNotes